import { RouteObject } from "react-router-dom";
import DriverLayout from "../../layout/DriverLayout";
import ChangePasswordPage from "../../pages/Driver/ChangePass";
import ChangeMobilePage from "../../pages/Driver/ChangeMobile";
import ChangeVehiclePage from "../../pages/Driver/ChangeVehicle";
import CommunicateCompanies from "../../pages/CommunicateCompanies";
import CompleteInfo from "../../pages/Driver/CompleteInfo";
import DashboardPage from "../../pages/Driver/Dashboard";
import GetCargoPage from "../../pages/Driver/GetCargo";
import GetTurnPage from "../../pages/Driver/GetTurn";
import KarenClubPage from "../../pages/Driver/KarenClub";
import CoursesPage from "../../pages/Driver/KarenClub/Courses";
import ManageFreights from "../../pages/Driver/ManageFreight";
import NotifsPage from "../../pages/Driver/Notifs";
import ProfilePage from "../../pages/Driver/Profile";
import EditProfile from "../../pages/Driver/Profile/EditProfile";
import SendTicketPage from "../../pages/Driver/SendTicketPage";
import TicketDetailsPage from "../../pages/Driver/SendTicketPage/TicketDetailsPage";
import SettingsPage from "../../pages/Driver/Settings";
import SuportPage from "../../pages/Driver/SuportPage";
import SurveyPage from "../../pages/Driver/SurveyPage";
import TenderOffer from "../../pages/Driver/TenderOffer";
import TenderOfferDetailsPage from "../../pages/Driver/TenderOfferDetailsPage";
import WalletPage from "../../pages/Driver/wallet";
import WithdrawWallet from "../../pages/Driver/WithdrawWallet";
import TrackingPage from "../../pages/Driver/TrackingPage";
import NotFound from "../../pages/NotFound";
import BolsHistories from "../../pages/Driver/BolsHistories";

const driverRoutes: RouteObject[] = [
  {
    path: "complete-info",
    element: <CompleteInfo />,
  },
  {
    path: "/driver/",
    element: <NotFound />,
  },
  {
    path: "/driver",
    element: <DriverLayout />,
    children: [
      {
        path: "dashboard",
        element: <DashboardPage />,
      },
      {
        path: "get-freight",
        element: <GetCargoPage />,
      },
      {
        path: "manage-freight",
        element: <ManageFreights />,
      },
      {
        path: "change-vehicle",
        element: <ChangeVehiclePage />,
      },
      {
        path: "complete-info",
        element: <CompleteInfo />,
      },
      {
        path: "ticket",
        element: <SuportPage />,
      },

      {
        path: "ticket/new-ticket",
        element: <SendTicketPage />,
      },
      {
        path: "ticket/:ticketId",
        element: <TicketDetailsPage />,
      },
      {
        path: "communicate-companies",
        element: <CommunicateCompanies />,
      },
      {
        path: "profile",
        element: <ProfilePage />,
      },
      {
        path: "edit-profile",
        element: <EditProfile />,
      },
      {
        path: "change-password",
        element: <ChangePasswordPage />,
      },
      {
        path: "change-mobile",
        element: <ChangeMobilePage />,
      },
      {
        path: "notifications",
        element: <NotifsPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "check-in",
        element: <GetTurnPage />,
      },
      {
        path: "wallet",
        element: <WalletPage />,
      },
      {
        path: "withdraw-wallet",
        element: <WithdrawWallet />,
      },
      {
        path: "karenclub",
        element: <KarenClubPage />,
      },
      {
        path: "karenclub/courses",
        element: <CoursesPage />,
      },
      {
        path: "tender-offer",
        element: <TenderOffer />,
      },
      {
        path: "tender-offer/:orderId",
        element: <TenderOfferDetailsPage />,
      },
      {
        path: "active-cargo",
        element: <TrackingPage />,
      },
      {
        path: "bols-histories",
        element: <BolsHistories />,
      },
      {
        path: "survey",
        element: <SurveyPage />,
      },
    ],
  },
];

export default driverRoutes;
